
import { Input } from 'components'
import { Dialog2 } from 'components/Dialog2'

export const EditRefsDialog = ({ attrs: { meeting, loading } }) => {
  loading = false

  const formData = {
    reservationCode: meeting.reservationCode
  }

  return {
    view ({ attrs: { meeting, loading, open, onsubmit } }) {
      return m(Dialog2, {
        open,
        save () {
          loading = true
          meeting.reservationCode = formData.reservationCode
          onsubmit()
        },
        heading: 'Edit Reservation Code',
        saving: loading
      }, [
        m('.flex.flex-col.gap-3', [
          m(Input, {
            label: 'Reservation Code',
            value: formData.reservationCode,
            type: 'text',
            oninput (value) {
              formData.reservationCode = value
            }
          })
        ])
      ])
    }
  }
}
